import * as React from 'react';

import {BrandingSettings} from 'types';

export const BrandingContext = React.createContext<BrandingSettings>({});

export function useBranding() {
  return React.useContext(BrandingContext);
}
